export default __webpack_public_path__ + "static/media/Print_certificate_Ar_2025_April.0865a28e.png";